import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { storesContext } from '../../../../stores/storesContext';
import ConfirmationModal from '../../../helpers/ConfirmationModal';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import SharedBlockInfoCard from '../../BlockInfoCard';
import UpdateBlockModal from './UpdateBlockModal';

const BlockInfoCard = ({ selectedBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  return (
    <SharedBlockInfoCard
      monitoringBlock={selectedBlock}
      headerActions={
        <>
          <div className='mr-2'>
            <UpdateBlockModal monitoringBlock={selectedBlock} />
          </div>
          <div>
            <ConfirmationModal
              title='Confirm Delete'
              bodyText='Are you sure you want to delete this block?'
              confirmAction={() => {
                return alcmStore
                  .deleteMonitoringBlock(selectedBlock.id)
                  .then(() => {
                    successToast('Successfully deleted block');
                  })
                  .catch((error) => {
                    console.error(error);
                    errorToast('Failed to delete block');
                  });
              }}
              showButton={{
                children: <FontAwesomeIcon icon={faTrash} />,
                props: {
                  className: 'text-danger',
                  variant: 'link',
                  size: 'sm'
                }
              }}
              confirmButton={{
                props: { variant: 'danger' }
              }}
            />
          </div>
        </>
      }
    />
  );
};

export default observer(BlockInfoCard);
